<div class="layoutBlock detailpage">
    <div class="detailpageSideLeft">
        <div style="float: right;">
            <div class="circle-icon">
                <div>
                    <img hisImage="job" class="inlineicon" title="{{'rm.erp.businesstripApplication' | hisUi}}">
                </div>
            </div>
        </div>
    </div>
    <div class="detailpageCenter">
        <h1>
            {{ ( 'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.overview' | hisUi) }}
        </h1>

        <his-dialog-header [showBackButton]="true" [showSaveButton]="false" [showResetButton]="false"
            (customEvent)="redirectToEditForm()" [showCustomButton]="true" [customButtonLabel]="'common.edit'">
            <ng-container dataBox>
                <strong>{{businesstripApplication.surname}}, {{businesstripApplication.firstname}}</strong>
                | <span
                    [title]="'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.applicationDate' | hisUi">{{businesstripApplication.applicationDate
                    | hisDate }}
                </span>
                | <span
                    [title]="'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.id' | hisUi">{{businesstripApplication.id}}</span>
            </ng-container>
        </his-dialog-header>

        <div class="details detailPresentationList">
            <p-panel
                header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData' | hisUi}}"
                [toggleable]="false">
                <erp-businesstripapplication-overview-traveldata [businesstripApplication]="businesstripApplication">
                </erp-businesstripapplication-overview-traveldata>
            </p-panel>
        </div>
    </div>
</div>